import React from 'react';
import { IProps } from './types';

export const EvVih: React.FC<IProps> = ({ w, h }) => {
  return (
    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 904 904" width={w} height={h}>
      <path className="a" style={{ fill: '#fefefe' }} d="m68.4 836.1v-771.3h770.3v771.3z" />
      <path
        fillRule="evenodd"
        className="b"
        style={{ fill: '#131718' }}
        d="m841.3 838.7h-775.5v-776.5h775.5zm-770.3-5.1h765.1v-766.1h-765.1z"
      />
      <path className="greyHeader" style={{ fill: '#2b9a48' }} d="m817.8 85.7v729.5h-728.6v-729.5z" />
      <path
        className="a"
        style={{ fill: '#fefefe' }}
        d="m234 642.8h-80.1c0 0 3.4-19 20.7-48.9 17.4-29.9 44.9-29 44.9-29h14.5v-446.4h436.2v626.3h-0.9l-37.7 40.5h-436.2l38.6-41.5z"
      />
      <path
        className="greyHeader"
        style={{ fill: '#2b9a48' }}
        d="m475.6 791.4c0 0 40.8-42.4 48.2-49.8 7.4-7.4 19-7.4 19-7.4h58.6l-55.4 55z"
      />
      <path
        className="greyHeader"
        style={{ fill: '#2b9a48' }}
        d="m672.1 438.9c0 0-68.8 0-81.7 0-12.8 0-19.9-9.7-19.9-9.7l-44.4-53.4-40.5 86.9 127.3 257.3c0 0-19.9 0-45.6 0-25.8 0-43.1-30.9-43.1-30.9l-103-204.5c0 0-3.2 81-5.8 115.1-2.5 34.1-25.1 30.9-25.1 30.9h-216.1c6.4-54.1 52.1-56.6 52.1-56.6 0 0 109.4 0 119.7 0 10.2 0 11.5-10.3 11.5-10.3l5.8-116.5 47.6-102.9h-53.4l-36.7 62.4c0 0-14.7 31.5-39.8 16.7-25.1-14.8-5.8-41.1-5.8-41.1 0 0 32.1-53.4 41.2-70.2 9-16.7 25.2-19.3 35.3-19.9 38.4-2.3 135.8 0 153.8 0 18 0 41.8 32.2 41.8 32.2l52.8 62.4 71.4-0.4z"
      />
      <path
        className="greyHeader"
        style={{ fill: '#2b9a48' }}
        d="m512.6 177.7c28.8 0 52.1 23.3 52.1 52.1 0 28.8-23.3 52.1-52.1 52.1-28.8 0-52.1-23.3-52.1-52.1 0-28.8 23.3-52.1 52.1-52.1z"
      />
    </svg>
  );
};
